import { useContext } from 'react';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import Session3DS from '../components/Session3DS';
import { AppContext } from '../context';
import { completePayment } from '../lib/paymentService';
import AdyenCore from '@adyen/adyen-web/dist/types/core';

export default function CardVerification({
  data,
  adyenSdk,
}: {
  data: PaymentAction | null;
  adyenSdk: AdyenCore;
}): JSX.Element {
  const context = useContext(AppContext);

  const handle3DSComplete = async (completedData: Record<string, unknown>) => {
    await completePayment(context, completedData);
  };

  return (
    <>
      {(data && (
        <Session3DS action={data} handleResult={handle3DSComplete} adyenSdk={adyenSdk} />
      )) || <p>No 3DS data</p>}
    </>
  );
}
